<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.bargains'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-steps
          :active="1"
          finish-status="success"
          simple
          class="create-bargain-step"
        >
          <el-step title="添加订单"></el-step>
          <el-step title="添加产品(批发)"></el-step>
          <el-step title="添加收款"></el-step>
        </el-steps>
        <el-form
          ref="objForm"
          :model="formObj"
          label-width="100px"
          size="small"
        >
          <div class="mg20">
            <fieldset>
              <legend class="center">
                <span class="float-left"> {{ $t("text.baseInfo") }}</span>
                <span v-if="$route.query.payBalance == 'true'" class="red">
                  {{ $t("customer.balance")
                  }}{{ $route.query.customerBalance | currency }}
                </span>
              </legend>
            </fieldset>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.productNo')"
                  :prop="'productNo'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('product.productNo')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-autocomplete
                    v-model.trim="formObj.productNo"
                    :fetch-suggestions="querySearchProductNo"
                    :trigger-on-focus="false"
                    style="width: 100%"
                    @blur="blurProductNo"
                    @select="handleSelectProductNo"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.productNo }}</div>
                      <span class="addr">{{ item.productNoAlias }}</span>
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.category')"
                  :prop="'categoryId'"
                >
                  <el-select
                    v-model="formObj.categoryId"
                    clearable
                    filterabler
                    @change="selsectCategory"
                  >
                    <el-option
                      v-for="category in categories"
                      :key="category.id"
                      :label="category.name"
                      :value="category.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="mgb10">
              <el-col :span="12">
                <fieldset>
                  <legend>{{ $t("product.color") }}</legend>
                </fieldset>
                <div class="noData" v-if="formObj.productNo == null">
                  {{ $t("prompt.placeSelectProductNo") }}
                </div>
                <div v-else>
                  <div class="noData" v-if="productNoColors.length == 0">
                    <span class="orange">{{
                      $t("prompt.productNoColor")
                    }}</span>
                  </div>
                  <el-row :gutter="10" v-else>
                    <el-col
                      :span="6"
                      v-for="(color, i) in productNoColors"
                      :key="i"
                    >
                      <el-checkbox
                        v-model="checkedColors"
                        :label="color"
                        @change="buildMatrix"
                        class="mgb10"
                        >{{ color }}</el-checkbox
                      >
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12">
                <fieldset>
                  <legend>{{ $t("product.size") }}</legend>
                </fieldset>
                <div class="noData" v-if="formObj.productNo == null">
                  {{ $t("prompt.placeSelectProductNo") }}
                </div>
                <div v-else>
                  <div class="noData" v-if="productNoSizes.length == 0">
                    <span class="orange">{{ $t("prompt.productNoSize") }}</span>
                  </div>
                  <el-row :gutter="10">
                    <el-col
                      :span="6"
                      v-for="(size, i) in productNoSizes"
                      :key="i"
                    >
                      <el-checkbox
                        v-model="checkedSizes"
                        :label="size"
                        @change="buildMatrix"
                        class="mgb10"
                        >{{ size }}</el-checkbox
                      >
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>

            <div class="mgb10" v-if="matrixShow">
              <fieldset>
                <legend>
                  产品数量
                  <small class="orange"
                    >数量不填忽略该单元格，成交价不填忽略该行</small
                  >
                </legend>
              </fieldset>
              <table class="matrix" cellspacing="5">
                <tr v-for="(row, i) in matrix" :key="i">
                  <td v-for="(cell, j) in row" :key="j">
                    <span v-if="i == 0 || j == 0">{{ cell }}</span>
                    <el-input
                      size="small"
                      class="quantity-input"
                      :placeholder="j == row.length - 1 ? '成交价' : '数量'"
                      v-model="matrix[i][j]"
                      v-else
                    ></el-input>
                  </td>
                </tr>
              </table>
            </div>
            <fieldset v-if="productNoAttributes.length != 0">
              <legend>{{ $t("product.specJson") }}</legend>
              <el-row :gutter="20" class="mgb10">
                <el-col
                  v-for="attribute in productNoAttributes"
                  :key="attribute.name"
                  :span="6"
                  class="mgb10"
                >
                  <el-input size="small" v-model.trim="attribute.value">
                    <template slot="prepend">
                      <div>
                        <raw-html-limit-number
                          :content="attribute.name"
                          :number="6"
                        />
                      </div>
                    </template>
                  </el-input>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset>
              <legend>
                {{ $t("text.remark") }}
                <small class="orange">将会附加到每个产品订单</small>
                <el-tag
                  v-for="(template, templateIndex) of remarkTemplates"
                  :key="templateIndex"
                  :effect="template.effect"
                  size="mini"
                  @click="selectRemarkTemplate(template, templateIndex)"
                  style="float: right"
                  class="cursor-pointer"
                >
                  {{ template.name }}
                </el-tag>
              </legend>

              <tinymce-editor
                ref="editor"
                v-model="formObj.remark"
                :height="300"
              ></tinymce-editor>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-row>
              <el-col :span="8" class="left">
                <div class="mgl10">
                  <el-checkbox v-model="ignoreDF">忽略本次添加产品</el-checkbox>
                </div>
              </el-col>
              <el-col :span="8" class="center">
                <el-button
                  type="success"
                  size="medium"
                  :loading="saveDoing"
                  :disabled="saveDoing"
                  @click="save('custom')"
                  plain
                  >+ {{ $t("orderTypes.custom") }}</el-button
                >
                <el-button
                  v-if="Permit.currentTenant().config.bulkOrder"
                  type="primary"
                  size="medium"
                  :loading="saveDoing"
                  :disabled="saveDoing"
                  @click="save('bulkOrder')"
                  plain
                  >+ {{ $t("orderTypes.bulk") }}</el-button
                >
                <el-button
                  v-if="!Permit.currentTenant().config.bulkOrder"
                  type="primary"
                  size="medium"
                  :loading="saveDoing"
                  :disabled="saveDoing"
                  @click="save('bulk')"
                  plain
                  >+ {{ $t("orderTypes.bulk") }}</el-button
                >
                <el-button
                  type="warning"
                  size="medium"
                  :loading="saveDoing"
                  :disabled="saveDoing"
                  @click="save('wholesale')"
                  plain
                  >+ {{ $t("orderTypes.wholesale") }}</el-button
                >
              </el-col>
              <el-col :span="8" class="right">
                产品添加完成
                <el-button
                  type="danger"
                  size="medium"
                  class="mgr10"
                  :loading="saveDoing"
                  :disabled="saveDoing"
                  @click="save('payment')"
                  plain
                  >+ {{ $t("action.payment") }}</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div
          class="wrapper"
          v-if="
            bargain != null &&
            bargain.orders != null &&
            bargain.orders.length != 0
          "
        >
          <newed-orders
            :bargain="bargain"
            :currencySymbol="currencySymbol"
          ></newed-orders>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ls from "store2";
import Util from "@/utils/index.js";
import Permit from "@/utils/permit.js";
import TinymceEditor from "@/components/TinymceEditor";
//
import Bargain from "@/api/bargain.js";
import Category from "@/api/category.js";
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Product from "@/api/product.js";
import Order from "@/api/order.js";
import Quotation from "@/api/quotation.js";
import NewedOrders from "./newedOrders";
import PrintTemplate from "@/api/printTemplate.js";

export default {
  components: {
    NewedOrders,
    TinymceEditor,
  },
  inject: ["reload"],

  data() {
    return {
      Permit: Permit,
      bargain: null,
      categories: [],
      colors: [],
      sizes: [],
      remarkTemplates: [],
      formObj: {
        productNo: null,
        categoryId: null,
        categoryName: null,
        unit: null,
        images: null,
        craftwork: null,
        remark: null,
        productBrand: null,
      },
      cnyRate: null,
      currencySymbol: null,
      products: [],
      productNoColors: [],
      productNoSizes: [],
      productNoAttributes: [],
      //
      productSizePrices: [],
      productWholesalePrice: [],
      productSalesPrice: [],
      categorySizes: [],
      //
      ignoreDF: false,
      checkedSizes: [],
      checkedColors: [],
      matrix: [],
      saveDoing: false,

      sizePrices: [],
    };
  },
  computed: {
    matrixShow() {
      return this.matrix.length > 1 && this.matrix[0].length > 1;
    },
  },
  created() {
    const self = this;
    axios
      .all([
        Bargain.findByUuid({ uuid: self.$route.query.bargainUuid }),
        Category.findByTenantId(),
        Size.findByTenantId(),
        Color.findByTenantId(),
        PrintTemplate.findByType({ type: "remark" }),
      ])
      .then(
        axios.spread(function (
          bargain,
          categories,
          sizes,
          colors,
          remarkTemplates
        ) {
          if (bargain.status === 200) {
            self.bargain = bargain.data.entity;
            // 币种
            // self.order.currency = self.bargain.currency;
            const currentCurrencies = ls.session("CURRENCIES");
            const currencyObj = currentCurrencies.find(
              (c) => c.code === self.bargain.currency
            );
            if (currencyObj != null) {
              self.cnyRate = currencyObj.cnyRate;
              self.currencySymbol = currencyObj.symbol;
            } else {
              self.cnyRate = 1;
              self.currencySymbol = self.bargain.currency;
            }
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
          if (remarkTemplates.status === 200) {
            self.remarkTemplates = remarkTemplates.data;
            if (self.remarkTemplates.length != 0) {
              for (const c of self.remarkTemplates) {
                Vue.set(c, "effect", "plain");
              }
            }
          } else {
            self.sysError();
          }
          // self.clearProduct();
        })
      );
  },

  methods: {
    selectRemarkTemplate(template, templateIndex) {
      for (const c of this.remarkTemplates) {
        c.effect = "plain";
      }
      this.remarkTemplates[templateIndex].effect = "dark";
      this.formObj.remark = template.content;
    },
    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      //
      self.clearProduct();
      //
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        self.products = res.data;
        if (self.products.length !== 0) {
          for (const p of self.products) {
            Vue.set(p, "value", p.productNo);
          }
        }
        cb(self.products);
      });
    },
    handleSelectProductNo(item) {
      const self = this;
      self.formObj.productNo = item.productNo;
      self.blurProductNo(item);
    },
    blurProductNo(item) {
      const self = this;
      if (item.productNo != null) {
        Product.findByProductNo({
          productNo: item.productNo,
        }).then(function (res) {
          if (res.data.code === 200) {
            const item = res.data.entity;
            self.formObj.categoryId = item.categoryId;
            self.formObj.categoryName = item.categoryName;
            self.selsectCategory();
            self.formObj.unit = item.unit;
            self.formObj.images = item.images;
            self.formObj.craftwork = item.craftwork;
            self.formObj.remark =
              (self.formObj.remark || "") + (item.introduction || "");
            self.formObj._productIntroduction = item.introduction;
            self.formObj.productBrand = item.brand;

            self.productNoColors = item.colors;
            self.productNoSizes = item.sizes;
            //
            self.productSizePrices = item.productSizePrices;
            self.productWholesalePrice = item.wholesalePrice;
            self.productSalesPrice = item.salesPrice;
            self.productSalesCurrency = item.salesCurrency;
            self.productNoAttributes = JSON.parse(item.customAttributeJson).map(
              (c) => {
                return { name: c, value: null };
              }
            );
          } else {
            self.clearProduct();
          }
          self.getQuotationPrice();
        });
      }
    },
    clearProduct() {
      const self = this;
      self.formObj.categoryId = null;
      self.formObj.categoryName = null;
      self.selsectCategory();
      self.formObj.unit = null;
      self.formObj.images = null;
      self.formObj.craftwork = null;
      self.formObj.remark = self.formObj.remark || "";
      self.formObj._productIntroduction = null;
      self.formObj.productBrand = null;

      // self.productNoColors = self.colors.map((c) => c.name);
      // self.productNoSizes = self.sizes.map((s) => s.name);
      self.productNoColors = [];
      self.productNoSizes = [];
      //
      self.productSizePrices = [];
      self.productWholesalePrice = null;
      self.productSalesPrice = null;
      self.productSalesCurrency = null;
      self.productSalesCnyRate = null;
      self.productSalesCurrencySymbol = null;
      self.quotationPrice = null;
      self.quotationSizePrices = [];
    },
    getQuotationPrice() {
      const self = this;
      if (self.formObj.productNo != null && self.formObj.productNo != "") {
        Quotation.findByCustomerIdAndProductNo(self.bargain.customerId, {
          productNo: self.formObj.productNo,
        }).then(function (res) {
          if (res.data.code === 200) {
            self.quotationPrice = res.data.entity.price;
            self.quotationSizePrices = res.data.entity.quotationSizePrices;
          } else {
            self.quotationPrice = null;
            self.quotationSizePrices = [];
          }
          // console.log("====", self.quotationSizePrices);
        });
      }
    },
    //
    selsectCategory() {
      const self = this;
      if (self.formObj.categoryId === "") {
        self.formObj.categoryId = null;
        self.formObj.categoryName = null;
      }
      self.categorySizes = [];
      if (self.formObj.categoryId != null && self.formObj.categoryId !== "") {
        const selsectCategoryObj = self.categories.find(
          (c) => c.id === self.formObj.categoryId
        );
        if (
          selsectCategoryObj &&
          selsectCategoryObj.sizes != null &&
          selsectCategoryObj.sizes.length !== 0
        ) {
          self.categorySizes = selsectCategoryObj.sizes;
        }
        if (selsectCategoryObj) {
          self.formObj.categoryName = selsectCategoryObj.name;
        }
      }
      // console.log("====categorySizes:", self.categorySizes);
      if (self.categorySizes.length != 0) {
        self.productNoSizes = self.categorySizes.map((cs) => cs.name);
      }
    },

    //==========

    save(type) {
      let self = this;
      const obj = {
        bargainUuid: self.bargain.uuid,
        hurry: self.$route.query.hurry,
        handOverAt: self.$route.query.handOverAt,
        createAt: self.$route.query.createAt,
        payBalance: self.$route.query.payBalance,
        customerBalance: self.$route.query.customerBalance,
      };
      if (self.ignoreDF == true) {
        if (type == "wholesale") {
          self.$router.go(0);
        } else {
          self.$router.push({
            path: "/normal/oms/bargains/new-" + type,
            query: obj,
          });
        }
        return;
      }
      self.$refs.objForm.validate((valid) => {
        if (valid) {
          let os = self.generateOrders();
          // console.log("====save:", os);
          if (os.length === 0) {
            self.$message.error(this.$t("prompt.atLeastOneValidDataFillIn"));
            return;
          }
          for (let o of os) {
            if (!Util.regexPrice(o.price)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("order.price")]),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(o.quantity) || o.quantity === "0") {
              self.$message({
                message: self.$t("rules.regex", [self.$t("text.quantity")]),
                type: "warning",
              });
              return;
            }

            if (
              o.productPrice == null ||
              o.productPrice === "0" ||
              o.productPrice == 0
            ) {
              o.productPrice = o.price;
            }
            o.remark = self.formObj.remark;
            o.specJson = JSON.stringify(
              self.productNoAttributes.filter(
                (c) => c.value !== null && c.value !== ""
              )
            );
          }

          //　账户余额结算判断
          if (self.$route.query.payBalance == "true") {
            let currentOrdersAmount = 0;
            for (const d of os) {
              currentOrdersAmount =
                Number(currentOrdersAmount) +
                Number(
                  Util.toFixed(
                    Number(d.price * d.quantity) + Number(d.extraCharge),
                    2
                  )
                );
            }
            let amount =
              Number(self.bargain.amount || 0) + Number(currentOrdersAmount);
            if (amount > self.$route.query.customerBalance) {
              self.$message({
                message: self.$t("prompt.customerBalanceNotEnougth"),
                type: "warning",
              });
              return;
            }
          }
          //=====

          // ===
          self.saveDoing = true;
          Order.insertBatch(os).then(function (res) {
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.saveSuccess"),
                type: "success",
              });
              if (type == "wholesale") {
                self.$router.go(0);
              } else {
                self.$router.push({
                  path: "/normal/oms/bargains/new-" + type,
                  query: obj,
                });
              }
              self.$eventHub.$emit("orderNew");
            } else {
              self.sysError();
            }
            self.saveDoing = false;
          });
        } else {
          return false;
        }
      });
    },

    generateOrders() {
      let self = this;
      let os = [];
      let colors = [];
      for (let i = 0; i < self.matrix.length; i++) {
        if (i == 0) {
          if (self.matrix[0].length > 2) {
            colors = this.matrix[0];
          }
          continue;
        }
        let row = this.matrix[i];
        for (let j = 0; j < row.length; j++) {
          if (j == 0 || j == row.length - 1) {
            continue;
          }
          if (
            self.matrix[i][row.length - 1] &&
            this.matrix[i][j] &&
            this.matrix[i][j] != ""
          ) {
            // console.log("====", self.matrix[i][0], "+++", colors[j]);
            os.push({
              serialNo: null,
              innerSerialNo: null,
              handOverAt: self.$route.query.handOverAt,
              createAt: self.$route.query.createAt,
              hurry: self.$route.query.hurry,
              currency: self.bargain.currency,
              settlementId: self.bargain.settleType === "now" ? 0 : null,
              bargainId: self.bargain.id,

              productNo: self.formObj.productNo,
              customerProductNo: null,
              categoryId: self.formObj.categoryId,
              categoryName: self.formObj.categoryName,
              productBrand: self.formObj.productBrand,

              color: colors[j],
              colorImage: null,
              size: self.matrix[i][0],
              quantity: self.matrix[i][j],
              productPrice: self.sizePrices.find(
                (sp) => sp.size == self.matrix[i][0]
              ).productPrice,
              price: self.matrix[i][row.length - 1],
              unit: self.formObj.unit,
              extraCharge: null,
              discountRate: null,
              images: self.formObj.images,
              specJson: null,
              craftwork: null,
              attachment: null,
              remark: null,
              dealSuggest: null,
              confirmAt: null,
              type: null,
            });
          }
        }
      }
      // console.log("this os: ", os);
      return os;
    },
    //=====
    buildMatrix() {
      const self = this;
      let mt = [];
      self.sizePrices = [];
      let headerRow = ["#"].concat(this.checkedColors.map((c) => c));
      headerRow.push("成交价");
      mt.push(headerRow);
      self.checkedSizes.forEach(function (size, i) {
        const currentSizeCNYPrice = self.computeCNYPrice(size);
        const currentSizeRatePrice = self.computeRatePrice(currentSizeCNYPrice);
        let rowN = new Array(headerRow.length);
        rowN[0] = size;
        rowN[headerRow.length - 1] = currentSizeRatePrice;
        // console.log(size, "===rowN:", JSON.stringify(rowN));
        mt.push(rowN);
        self.matrix = mt;
        //
        let obj = {
          size: size,
          CNYPrice: currentSizeCNYPrice,
          productPrice: currentSizeRatePrice,
        };
        self.sizePrices.push(obj);
      });
    },
    computeCNYPrice(size) {
      const self = this;
      // 产品对客户的规格报价
      if (
        self.quotationSizePrices.length != 0 &&
        self.quotationSizePrices.find((p) => p.size == size) != null &&
        self.quotationSizePrices.find((p) => p.size == size).price != null
      ) {
        return self.quotationSizePrices.find((p) => p.size == size).price;
      }
      // 产品对客户的报价
      if (self.quotationPrice !== null) {
        return self.quotationPrice;
      }
      // 产品规格批发价格
      if (
        self.bargain.customerType === "wholesale" &&
        self.productSizePrices.length != 0 &&
        self.productSizePrices.find((s) => s.size === size) &&
        self.productSizePrices.find((s) => s.size === size).wholesalePrice !=
          null
      ) {
        return self.productSizePrices.find((s) => s.size === size)
          .wholesalePrice;
      }
      // 产品规格批发价格
      if (
        self.bargain.customerType === "wholesale" &&
        self.productWholesalePrice != null &&
        self.productWholesalePrice != 0
      ) {
        return self.productWholesalePrice;
      }
      // 产品销售价币种
      const currentCurrencies = ls.session("CURRENCIES");
      const currencyObj = currentCurrencies.find(
        (c) => c.code === self.productSalesCurrency
      );
      if (currencyObj != null) {
        self.productSalesCnyRate = currencyObj.cnyRate;
        self.productSalesCurrencySymbol = currencyObj.symbol;
      } else {
        self.productSalesCnyRate = 1;
        self.productSalesCurrencySymbol = self.productSalesCurrency;
      }
      // 产品规格售价
      if (
        self.productSizePrices.length != 0 &&
        self.productSizePrices.find((s) => s.size === size) &&
        self.productSizePrices.find((s) => s.size === size).salesPrice != null
      ) {
        return (
          self.productSizePrices.find((s) => s.size === size).salesPrice *
          self.productSalesCnyRate
        );
      }
      // 产品售价
      return self.productSalesPrice * self.productSalesCnyRate;
    },
    computeRatePrice(CNYPrice) {
      const self = this;
      if (CNYPrice != null) {
        return Math.floor((CNYPrice / self.cnyRate) * 100) / 100;
      }
      return null;
    },
  },
};
</script>

<style scoped>
table.matrix td {
  font-size: 13px;
  color: #606266;
  font-weight: bold;
  width: 100px;
}
table.matrix tr:first-child td,
table.matrix tr td:first-child {
  background: #f8f8f9;
  padding: 7px 10px;
}
</style>
